import { PopupHost as SharedPopupHost } from '@safetyhub/ui';
import { MODAL_LAYER } from './modalLayers';
import { useAuthStore } from '../stores/auth';
import { dismissPopup, fetchActivePopups, markPopupSeen } from '../lib/popups';

/**
 * 공지 팝업 호스트의 **web 배선** — 큐·모달·두 버튼은 `packages/ui`의 `PopupHost`가 소유한다.
 *
 * ⚠️ **2026-10-26에 본체를 공용 패키지로 올렸다.** 같은 화면이 admin에도 필요해졌고(서버는 이미
 * 슈퍼관리자 토큰을 그 라우트에 받아 `ADMIN` surface로 판정하고 있었다 — 화면만 없었다), 본체를
 * 양쪽에 복사하면 갈라진다. 그래서 이 파일에 남는 것은 **앱 의존 셋을 주입하는 것**뿐이다:
 * 계정 id(auth store) · 조회·기록(api 클라이언트) · 오버레이 층(web 모달 층 상수).
 *
 * ⚠️ **동작·정책 서술을 여기 옮겨 적지 않는다** — 띄우는 시점, 조직 전환에 재조회하지 않는 이유,
 * 두 버튼의 축, 오버레이 닫기를 막은 2026-10-19 결정, `bodyScroll`이 지키는 것, 그리고 「전체
 * 내역 보기」 링크와 「여러 묶음 합치기」를 **아직 넣지 않은** 이유는 전부 그 공용 컴포넌트의
 * JSDoc이 정본이다. 두 자리에 적으면 한쪽이 낡는다.
 *
 * ⚠️ 주입 함수는 **모듈 수준 함수**를 그대로 넘긴다(인라인 화살표 금지) — 공용 호스트가 ref로
 * 한 겹 막아 두었지만, 참조가 안정적이면 그 방어에 의존할 일이 없다.
 */
export default function PopupHost() {
  const userId = useAuthStore((s) => s.user?.id ?? null);

  return (
    <SharedPopupHost
      viewerId={userId}
      fetchPopups={fetchActivePopups}
      markSeen={markPopupSeen}
      dismiss={dismissPopup}
      overlayZClassName={MODAL_LAYER.root}
      // 「전체 내역 보기」가 web에서 갈 자리 — **공개 업데이트 내역 페이지**다. 서버의 `linkUrl`을
      // 쓰지 않는 이유(한 칸이라 surface별로 못 가른다)는 `resolvePopupLinks` JSDoc이 정본이다.
      // ⚠️ admin의 짝은 같은 경로가 **아니다**(그쪽은 권한이 필요한 관리 화면이다).
      appLinkHref="/release-notes"
    />
  );
}
